import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  shareButton: {
    id: 'learn.sequence.share.button',
    defaultMessage: 'Share this content',
    description: 'share message button message',
  },
  shareModalTitle: {
    id: 'learn.sequence.share.modal.title',
    defaultMessage: 'Title',
    description: 'share message modal title',
  },
  shareModalBody: {
    id: 'learn.sequence.share.modal.body',
    defaultMessage: 'Copy the link below to share this content.',
    description: 'share message modal body',
  },
  shareQuote: {
    id: 'learn.sequence.share.quote',
    defaultMessage: 'Here\'s a fun clip from a class I\'m taking on @edXonline.\n',
    description: 'share message quote',
  },
});

export default messages;
